import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../common/components/runtime-context';
import { getLastPostSlug } from '../../selectors/last-post-slug-selectors';
import NoPostFound from '../no-post-found';
import PostPage from '../post-page';

class LastPostPage extends Component {
  render() {
    const { postSlug } = this.props;
    return postSlug ? <PostPage params={{ postSlug }} /> : <NoPostFound />;
  }
}

LastPostPage.propTypes = {
  postSlug: PropTypes.string,
};

const mapStateToProps = (state) => ({
  postSlug: getLastPostSlug(state),
});

export default connect(mapStateToProps)(LastPostPage);
